import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "~/lib/client";
import { handleApiError, handleResponse } from "~/utils/response";
import { Response } from "../type";
import { CreateTaskResponse } from "../type";
import { tasksKeys } from "./keys";
import { toast } from "sonner";
import { getApiProgram } from "~/lib/utils";
import { encountersKeys } from "../../pages/encounters/api/queries";
import { getRouteApi } from "@tanstack/react-router";

interface VitaminInfo {
    name: string;
}

interface MedicationPayload {
    name?: string;
    dosage?: string;
    cost?: number;
    duration?: string;
    quantity?: number;
    vitamin?: VitaminInfo | null;
    instructions?: string;
    notes?: string;
    // [key: string]: any; // For additionalProp1, additionalProp2, etc.
}

interface BaseTaskPayload {
    type: string;
    instructions?: string;
    medications?: MedicationPayload[];
    cost?: string | number;
    program?: string;
    session_id?: string;
}


interface DeleteTaskProps {
    task_id: string;
    encounter_id: string;
}



interface CreateTaskMutation extends BaseTaskPayload {
    encounter_id: string;
}


export const useCreateTaskMutation = () => {
    return useMutation<CreateTaskResponse, unknown, CreateTaskMutation>({
        mutationKey: tasksKeys.addRecommendedTask(),
        mutationFn: async (variables: CreateTaskMutation) => {
            try {
                const { encounter_id, ...payload } = variables;
                const response = await apiClient(`/admin/encounters/${encounter_id}/tasks`, {
                    method: "POST",
                    body: JSON.stringify(payload),
                });
                const result = await handleResponse<CreateTaskResponse>(response);

                if (result.success) {
                    return result.data;
                } else {
                    throw new Error(result.error || 'Failed to create task');
                }
            } catch (error) {
                throw handleApiError(error);
            }
        },
    });
};


export const useDeleteTaskMutation = (opts: DeleteTaskProps) => {
    const routeApi = getRouteApi("/(dashboard)/dashboard/$program")
    const { program } = routeApi.useParams()
    const queryClient = useQueryClient()
    return useMutation<Response, unknown, void>({
        mutationKey: tasksKeys.deleteTask(opts.task_id),
        mutationFn: async () => {
            try {
                const response = await apiClient(`/admin/encounters/${opts.encounter_id}/tasks/${opts.task_id}`, {
                    method: "DELETE",
                });
                const result = await handleResponse<Response>(response);

                if (result.success) {
                    return result.data;
                } else {
                    throw new Error(result.error || 'Failed to delete task');
                }
            } catch (error) {
                throw handleApiError(error);
            }
        },
        onSuccess: () => {
            // queryClient.clear();
            // navigate({ to: "/", search: { redirect: "/dashboard" } });
            toast.success("Appointment task deleted successfully!");
            queryClient.invalidateQueries({ queryKey: encountersKeys.encounters({program: getApiProgram(program)}) });
        },
    })
}